import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-modified-by',
  templateUrl: './modified-by.component.html',
  styleUrls: ['./modified-by.component.less']
})
export class ModifiedByComponent implements OnInit {

  @Input() item: any;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/popups/my-stuff/modified-by/modified-by.component.ts